/**
 * The top of the price range is open-ended, so the cap renders as "100+"
 * rather than a hard number. Callers pass the range's own max as `rangeMax`.
 */
export const formatAmount = (amount: number, rangeMax: number): string =>
  amount >= rangeMax ? `${amount}+` : `${amount}`;

export const formatMoney = (amount: number, rangeMax: number): string =>
  `$${formatAmount(amount, rangeMax)}`;

export const isUnbounded = (amount: number, rangeMax: number): boolean =>
  amount >= rangeMax;
